export const IN_PROGRESS_LABEL = 'In progress';
export const PROJECT_ENDED_TITLE = 'Project ended';
export const APPLICATION_PAUSED_TITLE = 'Application paused';
export const APPLICATION_ACCEPTED_TITLE = 'Application accepted';
export const IN_REVIEW_TITLE = 'In review';

export const TALENT_REVIEW_TITLE = 'Our talent team review';
export const CLIENT_REVIEW_TITLE = 'Client review';

export const SUBSCRIPTION_CLOSED_TEXT =
  'Your work with this client has ended. Thanks for your contribution.';

export const WITHDRAWN_TEXT =
  'You won’t be considered for this project, and we won’t send you further updates about it.';

export const WITHDRAWN_OUTCOME_TEXT =
  'You withdrew your application. You won’t be considered for this project, and we won’t send you further updates about it.';

export const PROJECT_CLOSED_TEXT =
  'Your role progress is saved for future applications.';

export const OFFER_CANCELLED_TEXT =
  'We no longer accept applications for this project.';

export const ENDED_OUTCOME_TEXT =
  'It didn’t work out this time. Keep your profile up to date for future opportunities.';

export const NOT_SELECTED_TEXT =
  'This project wasn’t the right fit, but your completed steps stay saved for your next applications.';

export const ROLE_ON_HOLD_TEXT =
  'This role is not verified, so your application is on hold. Our recruiter will review it and come back to you with the next steps.';

export const IN_REVIEW_TEXT =
  'No action is needed from you right now. We’ll review your application and contact you with the next steps.';

export const APPLICATION_ACCEPTED_TEXT =
  'Our team accepted your application for further review. We’ll contact you with the next steps.';

export const CLIENT_REVIEW_PREPARATION_TEXT =
  'Our team reviewed your application and confirmed you’re a potential fit for this project. We’ll let you know when your profile is presented to the client.';

export const CLIENT_REVIEW_TEXT =
  'Your profile has been sent to the client. We’ll contact you with their feedback and any next steps.';

export const SELECTED_BY_CLIENT_TEXT =
  'The client selected you for this project. We’ll contact you with the next steps.';

export const TEAM_CONFIRMED_FIT_TEXT =
  'Our team confirmed you’re a fit for this project.';

export const WAITLIST_CAPACITY_TEXT =
  "You're on the waitlist — we're at capacity for profiles like yours in this role.";

export const ROLE_NOT_VERIFIED_TEXT =
  'No luck this time. We will let you know when you can apply for this role again. In the meantime, feel free to explore other roles.';

export const VERIFIED_TEXT =
  'Verified by your recruiter. No need to repeat these checks.';

export const PAUSED_ROLE_TEXT =
  'Role verification is paused. Your completed checks are saved.';

export const ROLE_CHECKS_TEXT =
  'Skill test, call with Mark, recruiter review and technical interview.';
